// Constants previously in app-context.tsx

// Report types
export const SPAM = "spam";
export const INAPPROPRIATE = "inappropriate";
export const OTHER = "other";
export const REPORT = "report";

// Default form fields
export const defFields = () => ({
  title: "",
  text: "",
  price: "",
  brand: "",
  color: "",
  vin: "",
  mileage: "",
  category: "",
  categoryId: "",
  categoryGroupId: "",
  itemCondition: "",
  condition: "",
  shipsFrom: "",
  height: "",
  shippable: true,
  width: "",
  depth: "",
  weight: "",
  latitude: "",
  longitude: "",
  locationText: "",
  photos: [],
});